import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import IndexedDBClassificationRepository from "../Classifications/IndexedDBClassificationRepository";

export default class IndexedDBBrandRepository extends IndexedDBClassificationRepository {
    public readonly source: InternalIndexedDBDatabase["brands"];
    protected readonly dataTypeName = "Brand";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.brands;
    }
}
